import { AchievementsList } from '@/widgets/achievements-list';
import { DailyActivity } from '@/widgets/daily-activity';
import { FaqList } from '@/widgets/faq-list';
import { HeroBanner } from '@/widgets/hero-banner';
import { RewardsPromo } from '@/widgets/rewards-promo';
import { SeasonPrizes } from '@/widgets/season-prizes';
import { TopPlayers } from '@/widgets/top-players';
import { UserRankCard } from '@/widgets/user-rank-card';

import styles from './HomePage.module.scss';

export function HomePage() {
  // Прогнозы отсюда не грузятся: на главной их не видно, а нужны они были
  // только ради баланса Фанкоинов в шапке — теперь он приходит сводкой.
  return (
    <div className={styles.sections}>
      <HeroBanner />
      <UserRankCard />
      <DailyActivity />
      <AchievementsList />
      <RewardsPromo />
      <TopPlayers />
      <SeasonPrizes />
      <FaqList />
    </div>
  );
}
